<template>
  <!-- Videos -->
  <section class="py-5 bg-light" id="videos">
    <div class="container-fluid text-center">
      <div class="row align-items-center justify-content-center bg-aquamarine" style="height:15vh;">
        <div class="col-md-12">
          <h1 class="text-white">VÍDEOS</h1>
        </div>
      </div>
      <div class="row text-center">
        <div class="col-md-12">
          <div class="card-group">

            <a v-for="video in lastVideos" :key="video.youtube"
               :href="'https://www.youtube.com/watch?v=' + video.youtube"
               class="bg-primary card border noticia">
              <!-- 16:9 aspect ratio -->
              <div class="embed-responsive embed-responsive-16by9">
                <iframe class="embed-responsive-item" :src="'https://www.youtube.com/embed/' + video.youtube"></iframe>
              </div>
              <div class="card-body">
                <h6>{{ video.titulo }}</h6>
                <!--<p class="card-text"><small>{{ video.author }}</small></p>-->
              </div>
            </a>
          </div>
        </div>
        <div class="col-md-12">
          <a class="btn btn-danger btn-lg m-2"
             href="https://www.youtube.com/channel/UCpXMueIpPn7-wyIU5MD11FQ" target="_blank">Mais Vídeos</a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "BlocoVideos",
  computed: {
    lastVideos()
    {
      if (this.$store.state.videos) {
        return this.$store.state.videos;
      } else {
        return {"data": {"link":"","data":""} }
      }
    }
  }
}
</script>

<style scoped>
a.noticia {
  color: white;
  text-decoration: none;
  background-color: transparent;
  -webkit-text-decoration-skip: objects; }

a {
  color: #12bbad;
  text-decoration: none;
  background-color: transparent;
  -webkit-text-decoration-skip: objects; }
a:hover {
  color: white;
  text-decoration: underline; }
</style>